import { ResourceType } from '__types__';

/** Backend `resource_types.model` values (aligned with `__types__` via derivation). */
export type ResourceTypeMechanism = NonNullable<ResourceType['model']>;

export const RESOURCE_TYPE_MECHANISMS: ResourceTypeMechanism[] = [
  'INDIVIDUAL',
  'ORGANIZATION',
  'LOCATION',
  'ITEM',
  'TALENT',
  'AGENT'
];

export type CreateResourceTypeInput = {
  name: string;
  icon: string;
  mechanism: ResourceTypeMechanism;
};

export type UpdateResourceTypePatch = {
  name?: string;
  icon?: string;
  metastructure?: ResourceType['metastructure'];
  archived?: boolean;
  order?: number;
  internal?: boolean;
  restricted_groups?: number[];
};

export interface ResourceTypeApi {
  /**
   * Do not use for admin lists. GET /resource_types filters `archived = false`
   * and drops NULL archived rows, so the payload is incomplete vs auth/settings.
   * List source of truth: auth/settings → Redux → React Query seed.
   */
  list(): Promise<ResourceType[]>;
  get(id: number): Promise<ResourceType>;
  create(input: CreateResourceTypeInput): Promise<ResourceType>;
  update(id: number, patch: UpdateResourceTypePatch): Promise<ResourceType>;
  remove(id: number): Promise<void>;
  reorder(items: Array<{ id: number; order: number }>): Promise<void>;
}

/** Thrown by {@link ResourceTypeApi.list} and admin fetchList when Redux is empty. */
export const RESOURCE_TYPES_LIST_UNAVAILABLE_MESSAGE =
  'Resource types list is not available yet. It is loaded from auth/settings (Redux), not GET /resource_types — that endpoint filters archived = false and drops NULL archived rows, so it returns an incomplete list.';

export function throwResourceTypesListUnavailable(): never {
  throw new Error(RESOURCE_TYPES_LIST_UNAVAILABLE_MESSAGE);
}
